import script from "./productPriceLevels.vue?vue&type=script&lang=ts&setup=true"
export * from "./productPriceLevels.vue?vue&type=script&lang=ts&setup=true"

import "./productPriceLevels.vue?vue&type=style&index=0&id=1df1a9de&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df1a9de"]])

export default __exports__